<template>
  <p class="email-body-text" v-html="parsedMessage" />
</template>

<script>
import { variablesInspection } from '@/modules/maria/campanha-da-maria-v2/mixins/variables-inspection.js'

export default {
  name: 'BodyPreview',
  mixins: [variablesInspection],
}
</script>

<style lang="scss" scoped>
.email-body-text {
  color: $cinza-0;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
</style>
